import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import { useForBindingId } from '../../../forBinding';

export interface ExportDefensivesParams {
	format: 'pdf' | 'xlsx';
	filter?: string;
	class?: string | string[];
	nature?: string | string[];
	origin?: string | string[];
	manufacturer?: string | string[];
	sortAsc?: boolean;
}

export function useExportDefensives() {
	const forBinding = useForBindingId();
	return useMutation({
		mutationFn: async ({
			format,
			filter,
			class: className,
			nature,
			origin,
			manufacturer,
			sortAsc,
		}: ExportDefensivesParams) => {
			try {
				const params = new URLSearchParams();
				params.set('format', format);
				if (forBinding) params.set('forBinding', forBinding);
				if (filter) params.set('filter', filter);
				if (sortAsc !== undefined) params.set('sortAsc', String(sortAsc));

				const classes = Array.isArray(className) ? className : className ? [className] : [];
				const natures = Array.isArray(nature) ? nature : nature ? [nature] : [];
				const origins = Array.isArray(origin) ? origin : origin ? [origin] : [];
				const manufacturers = Array.isArray(manufacturer)
					? manufacturer
					: manufacturer
						? [manufacturer]
						: [];

				classes.forEach((item) => params.append('class', item));
				natures.forEach((item) => params.append('nature', item));
				origins.forEach((item) => params.append('origin', item));
				manufacturers.forEach((item) => params.append('manufacturer', item));

				const response = await api.get<Blob>('/agricultural-defensives/export', {
					params,
					responseType: 'blob',
				});
				const disposition = response.headers['content-disposition'] as string | undefined;
				const filename = disposition?.match(/filename="?([^";]+)"?/i)?.[1];
				return { file: response.data, filename: filename ?? `defensivos.${format}` };
			} catch (error) {
				throw toApiError(error, 'Erro ao exportar defensivos');
			}
		},
	});
}
